export const LANGUAGE_FLAG_MAX_SIZE = 2 * 1024 * 1024;

export const LANGUAGE_FLAG_ALLOWED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'image/webp',
  'image/svg+xml',
];

export const LANGUAGE_FLAG_ACCEPT = LANGUAGE_FLAG_ALLOWED_TYPES.join(',');

export const formatFlagFileSize = (size: number) => {
  if (size < 1024 * 1024) {
    return `${Math.ceil(size / 1024)} KB`;
  }

  return `${(size / (1024 * 1024)).toFixed(1)} MB`;
};

export const validateLanguageFlagFile = (file: File) => {
  if (!LANGUAGE_FLAG_ALLOWED_TYPES.includes(file.type)) {
    return 'Flag must be a PNG, JPEG, WebP, or SVG image';
  }

  if (file.size > LANGUAGE_FLAG_MAX_SIZE) {
    return `Flag must be ${formatFlagFileSize(LANGUAGE_FLAG_MAX_SIZE)} or smaller`;
  }

  return '';
};
